import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { MobileNav } from '../components/MobileNav';
import { Sparkles, Heart, Star, ArrowRight, BookOpen } from 'lucide-react';
import { Footer } from '../components/Footer';
import SEO, { pageSEO } from '../components/SEO';

export const AboutNumerologyPage = () => {
  return (
    <div className="min-h-screen swirl-bg">
      <SEO {...pageSEO.aboutNumerology} />
      <MobileNav />

      <main className="max-w-4xl mx-auto px-6 md:px-12 py-12">
        {/* Hero Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gradient-to-br from-purple-500 via-amber-400 to-pink-500 mb-8 glow-purple">
            <BookOpen className="w-12 h-12 text-white" />
          </div>
          <p className="font-whimsy text-2xl text-[#EC4899] mb-4 font-bold">
            ~ The Power of Numbers ~
          </p>
          <h1 className="font-mystical text-4xl md:text-5xl lg:text-6xl text-[#2D1B3D] font-bold mb-6">
            About Numerology
          </h1>
        </motion.div>

        {/* Main Message Card */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="ethereal-card rounded-3xl p-8 md:p-12 mb-12"
        >
          <div className="text-center mb-8">
            <div className="w-20 h-20 rounded-full bg-gradient-to-br from-[#8B5CF6] to-[#D4AF37] flex items-center justify-center mx-auto mb-6 shadow-xl">
              <Sparkles className="w-10 h-10 text-white" />
            </div>
          </div>
          
          <div className="space-y-6 text-center">
            <p className="text-[#2D1B3D] text-xl md:text-2xl leading-relaxed font-medium">
              <span className="font-mystical text-3xl md:text-4xl text-[#8B5CF6] block mb-4">
                "Numerology is God's Language."
              </span>
            </p>
            
            <p className="text-[#3D2A4D] text-lg md:text-xl leading-relaxed">
              Once you learn your core numbers you will be set free to then accomplish your mission in life.
            </p>
            
            <p className="text-[#3D2A4D] text-lg md:text-xl leading-relaxed">
              No more wandering aimlessly.
            </p>
            
            <p className="text-[#3D2A4D] text-lg md:text-xl leading-relaxed">
              You will finally get to view yourself in a whole different mirror.
            </p>
            
            <div className="py-6">
              <div className="w-24 h-1 bg-gradient-to-r from-[#8B5CF6] via-[#D4AF37] to-[#EC4899] mx-auto rounded-full"></div>
            </div>
            
            <p className="text-[#2D1B3D] text-xl md:text-2xl leading-relaxed font-semibold">
              You will never be the same again.
            </p>
            
            <p className="text-[#3D2A4D] text-lg md:text-xl leading-relaxed">
              Something shifts, you forgive your shortcomings, fear loses its grip, anxiety begins to fade, peace takes root and you come to the realization that God is reigning supreme as he made you to live your Life Path journey.
            </p>
            
            <div className="pt-6">
              <p className="font-whimsy text-2xl text-[#8B5CF6] font-bold">— Karine Burt</p>
            </div>
          </div>
        </motion.div>

        {/* CTA Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="text-center"
        >
          <h2 className="font-mystical text-3xl text-[#2D1B3D] font-bold mb-6">
            Ready to Discover Your Numbers?
          </h2>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/calculator" data-testid="about-cta-calculator">
              <Button className="rounded-full btn-magic px-8 py-5 text-lg font-bold">
                <Star className="w-5 h-5 mr-2" />
                Try Soulmate Calculator
              </Button>
            </Link>
            <Link to="/contact" data-testid="about-cta-contact">
              <Button 
                variant="outline" 
                className="rounded-full px-8 py-5 text-lg font-bold border-2 border-[#8B5CF6] text-[#8B5CF6] hover:bg-[#8B5CF6]/10"
              >
                <Heart className="w-5 h-5 mr-2" />
                Book a Reading
              </Button>
            </Link>
          </div>
        </motion.div>
      </main>

      <Footer />
    </div>
  );
};

export default AboutNumerologyPage;
